import { createTheme } from "@mui/material";
// import { createTheme } from "@mui/material/styles";
import { baseTheme } from "./base";

const customComponents = {
	AppFooter: {
		backgroundColor: 'gainsboro',
		borderTop: '1px solid #BDBDBD'
	}
}

const palette = {
	background: {
		default: 'rgba(4,101,98)' // App background
	},
	primary: {
		main: '#BDBDBD',
		text: '#ffffff',
		textBlack: '#000000'
	},
	secondary: {
		main: '#A75F06',
		dark: '#844A02',
		text: '#ffffff'
	},
	success: {
		light: '#b2d235'
	},
	error: {
		light: '#ff0000'
	},
}

export const greenTheme = createTheme(baseTheme, {
	palette,
	typography: {
		// fontFamily: '"Gill Sans"',
		welcome: {
			fontFamily: '"Bebas Neue", "Roboto"',
			fontWeight: 500,
			fontSize: '3.125rem',
			lineHeight: '.9',
			letterSpacing: '1.4px',
			color: palette.primary.text
		},
		title: {
			fontFamily: '"Bebas Neue", "Roboto"',
			fontWeight: 500,
			fontSize: '1.825rem',
			lineHeight: '1.035',
			letterSpacing: '1.2px',
			color: palette.primary.text
		},
		title2: {
			fontFamily: '"Nunito Sans", "Roboto"',
			margin: 0,
			fontWeight: 400,
			fontSize: '1rem',
			lineHeight: 1.35,
			color: palette.primary.text
		},
		subtitle: {
			fontFamily: '"Bebas Neue", "Roboto"',
			margin: 0,
			fontWeight: 400,
			fontSize: '1.2rem',
			lineHeight: 1.35,
			letterSpacing: '1.2px',
			marginTop: '12px',
			color: palette.primary.text
		},
		subtitle2: {
			fontFamily: '"Nunito Sans", "Roboto"',
			margin: 0,
			fontWeight: 400,
			fontSize: '.9rem',
			lineHeight: 1.35,
			marginTop: '12px',
			color: palette.primary.text
		},
		text: {
			fontFamily: '"Nunito Sans", "Roboto"',
			margin: 0,
			fontWeight: 300,
			fontSize: '.9rem',
			lineHeight: 1.35,
			marginTop: '12px',
			color: palette.primary.text
		},
		text_success: {
			fontFamily: '"Nunito Sans", "Roboto"',
			margin: 0,
			fontWeight: 400,
			fontSize: '.9rem',
			lineHeight: 1.35,
			marginTop: '12px',
			color: palette.primary.text
		}
	},
	components: {
		MuiAppBar: {
			defaultProps: {
				elevation: 0
			},
			styleOverrides: {
				root: {
					backgroundColor: palette.background.default,
					borderBottom: 'none'
				}
			}
		},
		MuiToolbar: {
			styleOverrides: {
				root: {
					backgroundColor: palette.background.default,
					borderBottom: 'none'
				}
			}
		},
		MuiButton: {
			defaultProps: {
				disableElevation: true
			},
			styleOverrides: {	
				textSizeMedium: {
					backgroundColor: palette.secondary.main
				},
				contained: {
					backgroundColor: palette.secondary.main,
					'&:hover': {
						backgroundColor: palette.secondary.main,
					}
				},
				containedSizeLarge: {
					maxHeight:'80px',
				},
				root: {
					fontFamily: '"Bebas Neue", "Roboto"',
					color: palette.secondary.text,
					// fontSize: '1rem',
					fontSize: '1.2rem',
					maxHeight:'40px',
					letterSpacing: '1.2px',

					fontWeight: 400,
					textTransform: 'unset',
					"&.Mui-disabled": {
						"opacity": 0.4,
						backgroundColor: palette.secondary.main,
						color: palette.secondary.text
					},
					'&:hover': {
						// backgroundColor: palette.secondary.dark,
						backgroundColor: 'transparent'
					}
				},
				sizeLarge: { // Increase button's height
					paddingTop: '12px',
					paddingBottom: '12px',
				}
			}
		},
		MuiLink: {
			styleOverrides: {
				root: {
					color: 'rgb(102, 60, 0)'
				}
			}
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					fontFamily: '"Nunito Sans", "Roboto"',
					color: palette.primary.text
				}
			}
		}
	},
}, customComponents);
